import { t } from "i18next"
import { LanguageDDL } from "../../Components/CommonDDL/LanguageDDL"
import { useNavigate } from "react-router-dom"

export const RegistrationHeader = (props) => {
    const { Language, setLanguage } = props

    const navigate = useNavigate()

    const handleLogoClick = () => {
        navigate("/")
    }

    return (
        <header className="am-topbar">
            <div className="am-shell am-topbar-inner">
                <img
                    src="assets/img/Logo/Logo.png"
                    className="am-topbar-logo am-clickable"
                    alt="आमची मुलगी"
                    onClick={handleLogoClick}
                />

                <div className="am-topbar-text">
                    <span className="am-eyebrow">Public Grievance Application</span>
                    <h1 className="am-topbar-title">
                        {t('CitizenRegistration.PublicGrievanceInAamchiMulgiScheme')}
                    </h1>
                </div>

                <div className="am-topbar-tools">
                    <span className="am-lang">
                        <LanguageDDL
                            Language={Language}
                            setLanguage={setLanguage}
                        />
                    </span>

                    <button
                        type="button"
                        className="am-btn am-btn--ghost am-home-btn"
                        onClick={handleLogoClick}
                        title="मुख्य पृष्ठ"
                    >
                        <i className="fa-solid fa-house"></i>
                    </button>
                </div>
            </div>
        </header>
    )

}
